module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PBJ5GU/tc-custom/Cover.jpg?1684515194086?1710184779603",
      "alt": "This image is the cover for the book Planet of the Apes: When Worlds Collide, Planet of the Apes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Planet of the Apes: When Worlds Collide, Planet of the Apes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In celebration of the original film’s 50th anniversary, stories from both eras of the Planet of the Apes franchise are featured together in one collection for the first time ever. These all-new stories include the reveal of the ape who calls the remains of the Statue of Liberty home, and the first look at the world left behind following the events of War for the Planet of the Apes.  Featuring bestselling authors Matt Kindt (Mind MGMT), Jeff Jensen (Green River Killer), and Dan Abnett (Guardians of the Galaxy), Planet of the Apes: When Worlds Collide is an unprecedented examination of the iconic franchise that fans of the original and new series will not want to miss.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matt Kindt, Ryan Ferrier, Dan Abnett, David F. Walker, Phillip Kennedy Johnson, Lalit Kumar-Sharma, Carlos Magno, Jared Cullum, Morgan Beem, Gabriel Cassata, Joana Lafuente\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0